module.exports = __webpack_public_path__ + "assets/img/f4c8e7f0e8f7bf14307e7f3ffe8c7a4c.png";